import { render } from "./AddAlarmcodeForSystem.vue?vue&type=template&id=57e7066c"
import script from "./AddAlarmcodeForSystem.vue?vue&type=script&lang=js"
export * from "./AddAlarmcodeForSystem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__